import React, { useState, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import { Typography, Button, Breadcrumb } from "antd";
import Icon, { CloseOutlined } from "@ant-design/icons";
import classnames from "classnames";

import { ListsKeys, lists } from "./LearnListMap";
import LearnTopicsList from "./LearnTopicsList/LearnTopicsList";

import "./Learn.scss";

const { Title } = Typography;

const BreadCrumbArrow = () => (
  <svg width="14" height="10" viewBox="0 0 14 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="0.25" y1="1.75" x2="11.75" y2="1.75" stroke="#4F4F4F" strokeWidth="0.5" strokeLinecap="round" />
    <path d="M14 1.75L11.375 3.26554V0.234456L14 1.75Z" fill="#4F4F4F" />
  </svg>
);

const Learn = ({ onToggle, className }) => {
  const [breadcrumbs, setBreadcrumbs] = useState(["Home"]);
  const [curKey, setCurKey] = useState(ListsKeys.HOME);

  const breadCrumbClickHandler = useCallback(
    (listkey) => {
      const targetIdx = breadcrumbs.indexOf(listkey);

      setBreadcrumbs(breadcrumbs.filter((_, idx) => idx <= targetIdx));
      setCurKey(listkey);
    },
    [breadcrumbs]
  );

  const breadcrumbList = useMemo(
    () =>
      breadcrumbs.map((text) => (
        <Breadcrumb.Item key={text} onClick={() => breadCrumbClickHandler(text)}>
          <Link to=""> {text} </Link>
        </Breadcrumb.Item>
      )),
    [breadcrumbs, breadCrumbClickHandler]
  );

  const listItemClickHandler = useCallback(
    (listKey) => {
      setBreadcrumbs([...breadcrumbs, listKey]);
      setCurKey(listKey);
    },
    [breadcrumbs]
  );

  return (
    <div className={classnames("learn", { [className]: className })}>
      <div className="learn__header">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Title>Learn</Title>
          <Button type="text" onClick={onToggle}>
            <CloseOutlined />
          </Button>
        </div>

        <Breadcrumb className="learn__breadcrumb" separator={<Icon className="" component={BreadCrumbArrow} />}>
          {breadcrumbList}
        </Breadcrumb>
      </div>

      <div className="learn__body">
        <LearnTopicsList items={lists[curKey] || []} onClick={listItemClickHandler} />
      </div>
    </div>
  );
};

export default React.memo(Learn);
